// @flow

import React, { Component } from 'react';
import radium from 'radium';

import baseball from '../../../static/images/Block2/baseball.png';
import stamp from '../../../static/images/Block2/stamp.png';

const styles = {
  cardWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 50,
    '@media (max-width: 768px)': {
      flexDirection: 'column',
    },
    '@media (max-width: 414px)': {
      padding: '0 10px',
    },
  },
  cardBlock: {
    width: 380,
    height: 240,
    borderRadius: 8,
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    margin: 20,
    '@media (max-width: 414px)': {
      width: '100%',
      height: 220,
    },
  },
  outerTitleBlock: {
    width: 190,
    height: 30,
    backgroundColor: '#6D973F',
    color: 'white',
    position: 'absolute',
    top: -30,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '#7777716b 2px 0px 18px',
    fontSize: 13,
    '@media (max-width: 414px)': {
      left: 30,
    },
  },
  innerTitleBlock: {
    width: 190,
    height: 34,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    position: 'absolute',
    boxShadow: '#7777716b 2px 0px 18px',
    top: 0,
    right: 0,
    fontSize: 13,
    color: '#6D973F',
    '@media (max-width: 414px)': {
      right: 30,
    },
  },
  baseball: {
    width: 50,
    height: 50,
    position: 'absolute',
    left: -25,
    top: -10,
  },
  baseballPlayerCheering: {
    width: 60,
    height: 70,
    position: 'absolute',
    right: -31,
    bottom: -13,
  },
  stamp: {
    width: 60,
    height: 60,
    position: 'absolute',
    right: -31,
    bottom: -13,
  },
  leftTriangle: {
    width: 0,
    hegith: 0,
    borderTop: '34px solid white',
    borderLeft: '34px solid transparent',
    position: 'absolute',
    left: -34,
  },
  rightTriangle: {
    width: 0,
    hegith: 0,
    borderBottom: '30px solid #6D973F',
    borderRight: '30px solid transparent',
    position: 'absolute',
    right: -30,
  },
  cardContentWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '0 40px',
    marginTop: 10,
  },
  contentIcon: {
    width: 300,
    height: 200,
  },
  contentWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#8F5827',
    fontSize: 13,
    width: 120,
    height: 120,
  },
  leftArrow: {
    width: 0,
    hegith: 0,
    borderTop: '7.5px solid transparent',
    borderBottom: '7.5px solid transparent',
    borderRight: '15px solid #6D973F',
    position: 'absolute',
  },
  rightArrow: {
    width: 0,
    hegith: 0,
    borderTop: '7.5px solid transparent',
    borderBottom: '7.5px solid transparent',
    borderLeft: '15px solid #6D973F',
    position: 'absolute',
  },
  greenDot: {
    width: 5,
    height: 5,
    borderRadius: '100%',
    backgroundColor: '#6D973F',
    position: 'absolute',
  },
};

type Props = {
  title: String,
  facebookURL: String,
  image: String,
};

class Type2Card extends Component<Props> {
  render() {
    const {
      title,
      facebookURL,
      image,
    } = this.props;
    return (
      <div style={styles.cardBlock}>
        <div style={styles.outerTitleBlock}>
          <div style={styles.rightTriangle} />
          <img style={styles.baseball} src={baseball} alt="棒球" />
          {title}
        </div>
        <div style={styles.innerTitleBlock}>
          <div style={styles.leftTriangle} />
          <img style={styles.stamp} src={stamp} alt="印章" />
        </div>
        <a
          href={facebookURL}
          style={styles.cardContentWrapper}
          target="_blank"
          rel="noopener noreferrer">
          <img style={styles.contentIcon} src={image} alt="投票圖" />
        </a>
      </div>
    );
  }
}

export default radium(Type2Card);
